import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SimulationDataService {
  navigateEvent: EventEmitter<void> = new EventEmitter<void>();
  private data: any=[];

  setData(data: any) {
    this.data = data;
  }

  getData(): any {
    return this.data;
  }

  getfirstData(){
    return this.data
  }
  setfirstData(data: any) {
    this.data = data;
  }
  constructor() { }
}